import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { updateGridBannerPriceCell } from '../../actions/banners-grid';
import { updateEditCellData } from '../../actions/grid-screen';
import { ErrorItem } from '../../components/ErrorsPresenter/ErrorsPresenter';
import {
    GridBannerPriceCell,
    GridBannerPriceCellProps
} from '../../components/GridBannerPriceCell/GridBannerPriceCell';
import { selectBannersPricesPopup } from '../../selectors/banners-prices';
import { getEditCellKey } from '../../service/GridHelpers/GridHelpers';
import { BannerPrice } from '../../typings/banners';
import { CellKeyFields } from '../../typings/common';
import { AdvType } from '../../typings/domain';
import { CurrencyCode } from '../../typings/graphql-grid';
import { GridEditCellStatus } from '../../typings/grid';
import { State } from '../../typings/state';
import { TDispatchProps } from '../../typings/utils';

export interface OwnProps {
    bannerType: AdvType;
    bannerId: string;
    index: number;
}

export interface StateProps {
    bannerPrice?: BannerPrice;
    isGridScrolling: boolean;
    isEditInProgress?: boolean;
    isSaveInProgress?: boolean;
    errors: ErrorItem[];
    cellKeysFields: CellKeyFields;
    workCurrency: CurrencyCode;
    isEditable: boolean;
}

export type DispatchProps = TDispatchProps<GridBannerPriceCellProps>;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { editCellsData, isGridScrolling } = state.grid;
    const { workCurrency } = state.grid.clientInfo;
    const {
        cellKeysFields,
        bannerPrice,
        errors,
        isEditable
    } = selectBannersPricesPopup(state, ownProps.index);

    const key = getEditCellKey(cellKeysFields);
    const isSaveInProgress =
        editCellsData[key] !== undefined ? editCellsData[key].isSaving : false;
    const isEditInProgress =
        editCellsData[key] !== undefined
            ? editCellsData[key].isEditInProgress
            : false;

    return {
        isSaveInProgress,
        errors,
        bannerPrice,
        isGridScrolling,
        cellKeysFields,
        isEditInProgress,
        workCurrency,
        isEditable
    };
};

const mapDispatchToProps = (
    dispatch: Dispatch<Action>,
    ownProps: OwnProps
): DispatchProps => {
    const { bannerId } = ownProps;
    return {
        updateBannerPrice: (bannerPrice: BannerPrice) => {
            dispatch(
                updateGridBannerPriceCell(
                    {
                        bannerId,
                        bannerPrice
                    },
                    'price'
                )
            );
        },
        onClearErrors: (
            cellKeysFields: CellKeyFields,
            data: GridEditCellStatus
        ) => {
            dispatch(updateEditCellData(cellKeysFields, data));
        }
    };
};

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: DispatchProps,
    ownProps: OwnProps
): GridBannerPriceCellProps => {
    return {
        ...stateProps,
        ...dispatchProps,
        bannerType: ownProps.bannerType
    };
};

export const EditableBannerPriceCellContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps,
    GridBannerPriceCellProps
>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(GridBannerPriceCell);
